var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.31952 1.8868C-0.106507 1.45517 -0.106507 0.755356 0.31952 0.323724C0.745546 -0.107908 1.43627 -0.107908 1.8623 0.323724L7.68048 6.21846C8.10651 6.65009 8.10651 7.34991 7.68048 7.78154L1.8623 13.6763C1.43627 14.1079 0.745546 14.1079 0.31952 13.6763C-0.106507 13.2446 -0.106507 12.5448 0.31952 12.1132L5.36631 7L0.31952 1.8868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.bb0b3555640c8b96b375ea1a310ee9ab.svg";
export { ForwardRef as ReactComponent };